import { render, staticRenderFns } from "./RentabilidadTab.vue?vue&type=template&id=4abf93f0&scoped=true"
import script from "./RentabilidadTab.vue?vue&type=script&lang=js"
export * from "./RentabilidadTab.vue?vue&type=script&lang=js"
import style0 from "./RentabilidadTab.vue?vue&type=style&index=0&id=4abf93f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abf93f0",
  null
  
)

export default component.exports